module.exports = __webpack_public_path__ + "img/BQ.3f06ada4.svg";